import { GatewayChargePointInMaintenanceModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point-in-maintenance.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChargePointsLastMessageCell } from './charge-points-last-message.cell';
import { ChargePointsLastMessageHeader } from './charge-points-last-message.header';

export const ChargePointsLastMessageColumn: IdentifiedColumnDef<
  GatewayChargePointInMaintenanceModel,
  GatewayChargePointInMaintenanceModel['lastHeartbeatTime']
> = {
  enableSorting: false,
  header: ChargePointsLastMessageHeader,
  cell: ChargePointsLastMessageCell,
};
